import { memo } from 'react';

import { cn } from '@air/utils-tailwind';

export type AirLogoProps = {
  className?: string;
};

/**
 * Air logo component for splash/login screens. Defaults to `h-12 w-auto
 * text-neutral-12`; pass `className` to override size (e.g. `h-8`) or color
 * (e.g. `text-black` for light-themed surfaces outside the panel).
 */
export const AirLogo = memo<AirLogoProps>(({ className }) => (
  <svg
    aria-hidden="true"
    className={cn('h-12 w-auto text-neutral-12', className)}
    fill="none"
    viewBox="0 0 1000 411.25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M583.2,146.09c18.98,0,35.07-15.65,35.07-35s-16.09-35-35.07-35-35.07,15.65-35.07,35,15.68,35,35.07,35Z"
      fill="currentColor"
    />
    <path
      d="M993.17,310.35c-9.06-9.47-25.15-7.81-34.64,2.46-25.98,28.82-49.89,50.22-84.56,50.22-14.85,0-20.21-9.04-20.21-22.64,0-16.88,4.13-32.94,11.13-51.86l23.92-66.28c6.19-17.29-2.9-35-21.45-35h-77.13c-6.12.05-11.88-.03-17.34-.23,1.64-12.13,2.49-24.07,2.49-35.58,0-53.51-26.81-75.32-60.21-75.32-30.51.4-63.94,23.47-63.94,70.4,0,36.03,20.52,65.47,65.38,80.12-21.85,67.99-69.63,136.4-122.7,136.4-16.08,0-25.58-12.36-25.58-28.39s3.7-30.45,11.55-52.69l21.85-60.93c6.19-16.88-2.9-33.74-20.62-33.74h-123.35c7.6-35.33,10.95-66.45,10.75-94.67C468.5,28.03,441.29.04,412.42.04c-47.07,0-102.53,49.42-192.68,199.59C68.98,221.66,0,272.42,0,342.44,0,381.13,25.58,410.35,68.47,410.35c76.48,0,119.35-61.28,181.9-165.62,41.76-4.65,89.42-7.31,142.36-7.94-5.31,17.06-11.5,35.33-18.63,55l-27.21,74.92c-9.89,27.59,1.23,43.64,19.38,43.64,11.13,0,20.62-7.41,26.41-23.04l32.57-90.15c7.75-21.38,14.37-41.5,19.94-60.5h98.43l-11.15,30.05c-9.89,27.16-15.26,47.76-15.26,69.17,0,46.51,26.81,74.52,76.7,74.52,78.57,0,142.38-85.35,168.61-174.89,8.71.75,17.92,1.18,27.72,1.18h41.23l-12.36,34.17c-9.06,25.1-16.49,47.76-16.49,72.03,0,35.4,19.79,67.51,68.47,67.51s91.98-30.05,122.09-64.22c8.66-9.87,9.49-25.93,0-35.8l-.02-.03ZM73.41,362.21c-16.49,0-23.91-9.47-23.91-21.41,0-40.3,49.11-69.6,137.65-86.68-34.81,56.86-72,108.08-113.73,108.08ZM281.92,192.47c64.42-103.49,104.87-143.11,121.03-143.11,9.89,0,16.09,6.18,16.09,43.21.23,27.56-3.65,58.09-12.51,94.72-45.59.25-87.1,1.98-124.61,5.18ZM699.09,146.52c0-16.46,7.02-23.47,16.09-23.47,7.83,0,14.02,10.7,14.02,32.11,0,8.04-.65,16.56-1.86,25.38-19.41-6.33-28.24-17.36-28.24-34.02Z"
      fill="currentColor"
    />
  </svg>
));

AirLogo.displayName = 'AirLogo';
